import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/Blackprofileapplication.css";
import ApiService from "../nhrc_apis/ApiService";

const Blackprofileapplication = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    employeeName: "",
    designation:  "",
    photo:        null,
    status:       "",
    uan:          "",
    empId:        "",
    aadhar:       "",
    pan:          "",
    email:        "",
    phone:        "",
    location:     "",
    department:   "",
    modeOfWork:   "",
    reportingTo:  "",
    doj:          "",
    experience:   "",
    remarks:      "",
    documentName: "",
    documentFile: null,
    hrName:       "",
    organisation: "",
    hrDepartment: "",
  });

  const [errors, setErrors] = useState({});

  // ✅ ADDED — get membership_id from token, used for upload requests
  const getMembershipId = () => {
    const token =
      localStorage.getItem("hrToken") ||
      localStorage.getItem("token");
    if (!token) return "UNKNOWN";
    try {
      const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      const decoded = JSON.parse(window.atob(base64));
      return decoded?.membership_id || "UNKNOWN";
    } catch {
      return "UNKNOWN";
    }
  };

  const validateField = (name, value) => {
    let error = "";

    switch (name) {

      case "employeeName":
        if (!value || !value.trim()) {
          error = "Employee name is required.";
        } else if (value.trim().length < 3) {
          error = "Employee name must be at least 3 characters.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "Employee name must contain only letters and spaces.";
        }
        break;

      case "designation":
        if (!value || !value.trim()) {
          error = "Designation is required.";
        } else if (value.trim().length < 2) {
          error = "Designation must be at least 2 characters.";
        }
        break;

      case "photo":
        if (!value) {
          error = "Photo is required.";
        } else {
          const allowed = ["image/jpeg", "image/png", "image/jpg"];
          if (!allowed.includes(value.type)) {
            error = "Only JPG or PNG files are allowed for photo.";
          } else if (value.size > 5 * 1024 * 1024) {
            error = "Photo size must be less than 5MB.";
          }
        }
        break;

      case "status":
        if (!value) {
          error = "Status is required.";
        }
        break;

      case "uan":
        if (!value || !value.trim()) {
          error = "UAN number is required.";
        } else if (!/^[0-9]{12}$/.test(value.trim())) {
          error = "UAN number must be exactly 12 digits.";
        }
        break;

      case "empId":
        if (!value || !value.trim()) {
          error = "Employee ID is required.";
        } else if (value.trim().length < 2) {
          error = "Employee ID must be at least 2 characters.";
        }
        break;

      case "aadhar":
        if (!value || !String(value).trim()) {
          error = "Aadhar number is required.";
        } else if (!/^[0-9]{12}$/.test(String(value).trim())) {
          error = "Aadhar number must be exactly 12 digits.";
        }
        break;

      case "pan":
        if (!value || !value.trim()) {
          error = "PAN number is required.";
        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value.trim().toUpperCase())) {
          error = "Enter a valid PAN number (e.g. ABCDE1234F).";
        }
        break;

      case "email":
        if (!value || !value.trim()) {
          error = "Email is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) {
          error = "Enter a valid email address (e.g. name@example.com).";
        }
        break;

      case "phone":
        if (!value || !String(value).trim()) {
          error = "Phone number is required.";
        } else if (!/^[0-9]{10}$/.test(String(value).trim())) {
          error = "Phone number must be exactly 10 digits.";
        }
        break;

      case "location":
        if (!value || !value.trim()) {
          error = "Location is required.";
        } else if (value.trim().length < 2) {
          error = "Location must be at least 2 characters.";
        }
        break;

      case "department":
        if (!value || !value.trim()) {
          error = "Department is required.";
        } else if (value.trim().length < 2) {
          error = "Department must be at least 2 characters.";
        }
        break;

      case "modeOfWork":
        if (!value || !value.trim()) {
          error = "Mode of work is required.";
        }
        break;

      case "reportingTo":
        if (!value || !value.trim()) {
          error = "Reporting to is required.";
        } else if (value.trim().length < 2) {
          error = "Reporting to must be at least 2 characters.";
        }
        break;

      case "doj":
        if (!value) {
          error = "Date of joining is required.";
        } else {
          const dojDate = new Date(value);
          const today   = new Date();
          if (dojDate > today) {
            error = "Date of joining cannot be in the future.";
          }
        }
        break;

      case "experience":
        if (!value || !value.trim()) {
          error = "Experience is required.";
        }
        break;

      case "documentName":
        if (!value || !value.trim()) {
          error = "Document name is required.";
        } else if (value.trim().length < 2) {
          error = "Document name must be at least 2 characters.";
        }
        break;

      case "documentFile":
        if (!value) {
          error = "Document file is required.";
        } else if (value.size > 10 * 1024 * 1024) {
          error = "Document size must be less than 10MB.";
        }
        break;

      case "hrName":
        if (!value || !value.trim()) {
          error = "HR name is required.";
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = "HR name must contain only letters and spaces.";
        } else if (value.trim().length < 3) {
          error = "HR name must be at least 3 characters.";
        }
        break;

      case "organisation":
        if (!value || !value.trim()) {
          error = "Organisation is required.";
        } else if (value.trim().length < 2) {
          error = "Organisation must be at least 2 characters.";
        }
        break;

      case "hrDepartment":
        if (!value || !value.trim()) {
          error = "HR department is required.";
        } else if (value.trim().length < 2) {
          error = "HR department must be at least 2 characters.";
        }
        break;

      default:
        break;
    }

    return error;
  };

  const validateAll = () => {
    const fields = [
      "employeeName", "designation", "photo", "status",
      "uan", "empId", "aadhar", "pan",
      "email", "phone", "location",
      "department", "modeOfWork", "reportingTo", "doj", "experience",
      "documentName", "documentFile",
      "hrName", "organisation", "hrDepartment",
    ];

    const newErrors = {};
    fields.forEach((field) => {
      const error = validateField(field, form[field]);
      if (error) newErrors[field] = error;
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });

    const error = validateField(name, value);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleFile = (e) => {
    const { name } = e.target;
    const file = e.target.files[0] || null;
    setForm({ ...form, [name]: file });

    const error = validateField(name, file);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSubmit = async () => {
    const isValid = validateAll();

    if (!isValid) {
      alert("Please fill all required fields correctly before submitting.");
      return;
    }

    try {
      setLoading(true);

      const membershipId = getMembershipId();

      // STEP 1 — Upload Document
      let document_url = "";
      const docFormData = new FormData();
      docFormData.append("file", form.documentFile);

      const docResponse = await ApiService.HrBlackProfilesAPI.uploadDocument(docFormData);
      console.log("DOCUMENT UPLOAD RESPONSE:", docResponse.data);

      document_url =
        docResponse.data?.url          ||
        docResponse.data?.file_url     ||
        docResponse.data?.document_url ||
        docResponse.data?.data?.url    ||
        "";

      // STEP 2 — Upload Photo if selected
      // ✅ FIXED — added required membership_id + file_type fields
      let photo_url = "";
      if (form.photo) {
        const photoFormData = new FormData();
        photoFormData.append("file", form.photo);
        photoFormData.append("membership_id", membershipId);
        photoFormData.append("file_type", "black_profile_photo");

        const photoResponse = await ApiService.UploadAPI.uploadFile(photoFormData);
        console.log("PHOTO UPLOAD RESPONSE:", photoResponse.data);

        photo_url =
          photoResponse.data?.file_url ||
          photoResponse.data?.fileUrl ||
          photoResponse.data?.url ||
          photoResponse.data?.file_path ||
          "";
      }

      // STEP 3 — Build payload
      const payload = {
        employee_name:   form.employeeName,
        designation:     form.designation,
        status:          form.status,
        uan_number:      form.uan,
        employee_id:     form.empId,
        aadhaar_number:  form.aadhar,
        pan_number:      form.pan,
        email:           form.email,
        phone:           form.phone,
        location:        form.location,
        department:      form.department,
        mode_of_work:    form.modeOfWork,
        reporting_to:    form.reportingTo,
        date_of_joining: form.doj
          ? new Date(form.doj).toISOString()
          : new Date().toISOString(),
        experience:      form.experience,
        remarks:         form.remarks,
        document_name:   form.documentName,
        document_url:    document_url,
        photo_url:       photo_url,
        hr_name:         form.hrName,
        organisation:    form.organisation,
        hr_department:   form.hrDepartment,
      };

      console.log("PAYLOAD:", payload);

      // STEP 4 — Create Black Profile
      const createResponse = await ApiService.HrBlackProfilesAPI.createBlackProfile(payload);
      console.log("CREATE BLACK PROFILE RESPONSE:", createResponse.data);

      alert("Submitted Successfully");
      navigate("/hrdashboard/Blackprofile");

    } catch (err) {
      console.error("SUBMIT ERROR:", err);
      console.error("FULL VALIDATION DETAIL:", JSON.stringify(err?.response?.data?.detail, null, 2));
      alert(
        err?.response?.data?.message     ||
        err?.response?.data?.detail?.[0]?.msg ||
        "Submission failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setForm({
      employeeName: "",
      designation:  "",
      photo:        null,
      status:       "",
      uan:          "",
      empId:        "",
      aadhar:       "",
      pan:          "",
      email:        "",
      phone:        "",
      location:     "",
      department:   "",
      modeOfWork:   "",
      reportingTo:  "",
      doj:          "",
      experience:   "",
      remarks:      "",
      documentName: "",
      documentFile: null,
      hrName:       "",
      organisation: "",
      hrDepartment: "",
    });
    setErrors({});
  };

  return (
    <section className="bpasection">
      <div className="bpa-container">
        <h2 className="bpa-title">Black Profile Application</h2>

        <div className="bpa-section">
          <div className="bpa-section-header">EMPLOYEE DETAILS</div>
          <div className="bpa-form">

            <div className="bpa-field">
              <label className="bpa-label">Name of the Employee*</label>
              <input
                type="text" name="employeeName"
                value={form.employeeName}
                onChange={handleChange}
                placeholder="Enter employee name"
                className={errors.employeeName ? "input-error" : ""}
              />
              {errors.employeeName && <span className="error-text">{errors.employeeName}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Designation*</label>
              <input
                type="text" name="designation"
                value={form.designation}
                onChange={handleChange}
                placeholder="Enter designation"
                className={errors.designation ? "input-error" : ""}
              />
              {errors.designation && <span className="error-text">{errors.designation}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Upload Photo*</label>
              <input
                type="file" name="photo"
                accept=".jpg,.jpeg,.png"
                onChange={handleFile}
                className={errors.photo ? "input-error" : ""}
              />
              {errors.photo && <span className="error-text">{errors.photo}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Status*</label>
              <select
                name="status"
                value={form.status}
                onChange={handleChange}
                className={errors.status ? "input-error" : ""}
              >
                <option value="">Select</option>
                <option value="Active">Active</option>
                <option value="IN-Active">IN-Active</option>
              </select>
              {errors.status && <span className="error-text">{errors.status}</span>}
            </div>

          </div>
        </div>

        <div className="bpa-section">
          <div className="bpa-section-header">IDENTIFIERS</div>
          <div className="bpa-form">

            <div className="bpa-field">
              <label className="bpa-label">UAN Number*</label>
              <input
                type="text" name="uan"
                value={form.uan}
                onChange={handleChange}
                placeholder="Enter 12-digit UAN number"
                maxLength={12}
                className={errors.uan ? "input-error" : ""}
              />
              {errors.uan && <span className="error-text">{errors.uan}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Employee ID*</label>
              <input
                type="text" name="empId"
                value={form.empId}
                onChange={handleChange}
                placeholder="Enter employee ID"
                className={errors.empId ? "input-error" : ""}
              />
              {errors.empId && <span className="error-text">{errors.empId}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Aadhar Number*</label>
              <input
                type="text" name="aadhar"
                value={form.aadhar}
                onChange={handleChange}
                placeholder="Enter 12-digit Aadhar number"
                maxLength={12}
                className={errors.aadhar ? "input-error" : ""}
              />
              {errors.aadhar && <span className="error-text">{errors.aadhar}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Pan Number*</label>
              <input
                type="text" name="pan"
                value={form.pan}
                onChange={(e) => {
                  handleChange({
                    target: { name: "pan", value: e.target.value.toUpperCase() }
                  });
                }}
                placeholder="e.g. ABCDE1234F"
                maxLength={10}
                className={errors.pan ? "input-error" : ""}
              />
              {errors.pan && <span className="error-text">{errors.pan}</span>}
            </div>

          </div>
        </div>

        <div className="bpa-section">
          <div className="bpa-section-header">CONTACT</div>
          <div className="bpa-form">

            <div className="bpa-field">
              <label className="bpa-label">Email ID*</label>
              <input
                type="email" name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter email address"
                className={errors.email ? "input-error" : ""}
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Phone Number*</label>
              <input
                type="text" name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Enter 10-digit phone number"
                maxLength={10}
                className={errors.phone ? "input-error" : ""}
              />
              {errors.phone && <span className="error-text">{errors.phone}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Location*</label>
              <input
                type="text" name="location"
                value={form.location}
                onChange={handleChange}
                placeholder="Enter location"
                className={errors.location ? "input-error" : ""}
              />
              {errors.location && <span className="error-text">{errors.location}</span>}
            </div>

          </div>
        </div>

        <div className="bpa-section">
          <div className="bpa-section-header">EMPLOYMENT</div>
          <div className="bpa-form">

            <div className="bpa-field">
              <label className="bpa-label">Department*</label>
              <input
                type="text" name="department"
                value={form.department}
                onChange={handleChange}
                placeholder="Enter department"
                className={errors.department ? "input-error" : ""}
              />
              {errors.department && <span className="error-text">{errors.department}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Mode of Work*</label>
              <input
                type="text" name="modeOfWork"
                value={form.modeOfWork}
                onChange={handleChange}
                placeholder="e.g. Remote, Hybrid, Onsite"
                className={errors.modeOfWork ? "input-error" : ""}
              />
              {errors.modeOfWork && <span className="error-text">{errors.modeOfWork}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Reporting to*</label>
              <input
                type="text" name="reportingTo"
                value={form.reportingTo}
                onChange={handleChange}
                placeholder="Enter reporting manager name"
                className={errors.reportingTo ? "input-error" : ""}
              />
              {errors.reportingTo && <span className="error-text">{errors.reportingTo}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Date of joining*</label>
              <input
                type="date" name="doj"
                value={form.doj}
                onChange={handleChange}
                className={errors.doj ? "input-error" : ""}
              />
              {errors.doj && <span className="error-text">{errors.doj}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Experience*</label>
              <input
                type="text" name="experience"
                value={form.experience}
                onChange={handleChange}
                placeholder="e.g. 2 years"
                className={errors.experience ? "input-error" : ""}
              />
              {errors.experience && <span className="error-text">{errors.experience}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Status*</label>
              <select
                name="status"
                value={form.status}
                onChange={handleChange}
                className={errors.status ? "input-error" : ""}
              >
                <option value="">Select</option>
                <option value="IT">IT</option>
                <option value="Non-IT">Non-IT</option>
              </select>
              {errors.status && <span className="error-text">{errors.status}</span>}
            </div>

          </div>
        </div>

        <div className="bpa-section">
          <div className="bpa-section-header">REMARKS</div>
          <div className="bpa-form">
            <div className="bpa-field bpa-field-full">
              <label className="bpa-label">Remarks</label>
              <input
                type="text" name="remarks"
                value={form.remarks}
                onChange={handleChange}
                placeholder="Enter remarks (optional)"
              />
            </div>
          </div>
        </div>

        <div className="bpa-section">
          <div className="bpa-section-header">DOCUMENTS</div>
          <div className="bpa-form">

            <div className="bpa-field">
              <label className="bpa-label">Name of the Document*</label>
              <input
                type="text" name="documentName"
                value={form.documentName}
                onChange={handleChange}
                placeholder="Enter document name"
                className={errors.documentName ? "input-error" : ""}
              />
              {errors.documentName && <span className="error-text">{errors.documentName}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Upload Document*</label>
              <input
                type="file" name="documentFile"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                onChange={handleFile}
                className={errors.documentFile ? "input-error" : ""}
              />
              {errors.documentFile && <span className="error-text">{errors.documentFile}</span>}
            </div>

          </div>
        </div>

        <div className="bpa-section">
          <div className="bpa-section-header">HR DETAILS</div>
          <div className="bpa-form">

            <div className="bpa-field">
              <label className="bpa-label">Name of the HR*</label>
              <input
                type="text" name="hrName"
                value={form.hrName}
                onChange={handleChange}
                placeholder="Enter HR name"
                className={errors.hrName ? "input-error" : ""}
              />
              {errors.hrName && <span className="error-text">{errors.hrName}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Organisation*</label>
              <input
                type="text" name="organisation"
                value={form.organisation}
                onChange={handleChange}
                placeholder="Enter organisation name"
                className={errors.organisation ? "input-error" : ""}
              />
              {errors.organisation && <span className="error-text">{errors.organisation}</span>}
            </div>

            <div className="bpa-field">
              <label className="bpa-label">Department*</label>
              <input
                type="text" name="hrDepartment"
                value={form.hrDepartment}
                onChange={handleChange}
                placeholder="Enter HR department"
                className={errors.hrDepartment ? "input-error" : ""}
              />
              {errors.hrDepartment && <span className="error-text">{errors.hrDepartment}</span>}
            </div>

          </div>
        </div>

        <div className="bpa-action-container">
          <button
            className="bpa-submit-btn"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
          <button
            className="bpa-clear-btn"
            onClick={clearForm}
            disabled={loading}
          >
            Clear
          </button>
          <button
            className="bpa-back-btn"
            onClick={() => navigate(-1)}
            disabled={loading}
          >
            Back
          </button>
        </div>

      </div>
    </section>
  );
};

export default Blackprofileapplication;